<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="420px"
    append-to-body
    custom-class="esign-check-dialog"
  >
    <div class="esign-check-content">
      <div style="display: flex; align-items: center; margin-bottom: 16px;">
        <div v-html="iconHtml"></div>
        <div style="font-weight: bold; font-size: 16px; color: #333;">
          {{ title }}
        </div>
      </div>
      <div style="font-weight: bold; font-size: 16px; color: #333; margin-bottom: 8px;">
        {{ message || '您尚未授权E签宝印章，无法发起线上签约' }}
      </div>
      <div style="color: #666; font-size: 14px; line-height: 22px;">
        {{ subMessage || '为了保障合同签署的法律效力，请先完成E签宝印章授权，授权后即可开始使用线上签约功能。' }}
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">{{ cancelButtonText }}</el-button>
      <el-button
        type="primary"
        :loading="submitLoading"
        @click="handleConfirm"
      >{{ confirmButtonText }}</el-button>
      <el-button type="text" v-if="showNoRemind" @click="handleNoRemind">不再提醒</el-button>
    </span>
  </el-dialog>
</template>

<script>
import router from '@/router'

export default {
  name: 'ESignCheckDialog',
  data() {
    return {
      visible: false,
      title: '',
      message: '',
      subMessage: '',
      iconHtml: '',
      confirmButtonText: '',
      cancelButtonText: '',
      resolve: null,
      reject: null,
      showNoRemind: false,
      submitLoading: false,
    }
  },
  mounted() {
    router.afterEach(() => {
      if (this.visible) {
        this.handleCancel()
      }
    })
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    show(options) {
      this.submitLoading = false
      this.title = options.title
      this.message = options.message
      this.subMessage = options.subMessage
      this.iconHtml = options.iconHtml
      this.confirmButtonText = options.confirmButtonText
      this.cancelButtonText = options.cancelButtonText
      this.showNoRemind = options.showNoRemind

      this.visible = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    handleConfirm() {
      if (this.submitLoading) return
      this.submitLoading = true
      this.visible = false
      this.resolve && this.resolve({ action: 'confirm' })
    },
    handleCancel() {
      this.visible = false
      this.resolve && this.resolve({ action: 'cancel' })
    },
    handleNoRemind() {
      this.visible = false
      this.resolve && this.resolve({ action: 'noRemind' })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    display: none;
}
::v-deep .el-dialog__body {
    padding: 24px;
}
</style>
